<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Empresas</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Empresas',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn v-if="$check(['customers.create'])" id="btnNew" type="button" color="primary"
                            elevation="0" to="/empresas/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="identification" label="CPF/CNPJ"
                                        v-model="dataList.filter.identification" hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="name" label="E-mail" v-model="dataList.filter.email"
                                        hide-details outlined></v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum empresa encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.name`]="{ item }">
                                <span class="text-uppercase">
                                    <strong>{{ item.name }}</strong>
                                    <br>
                                    {{ $formatCpfCnpj(item.identification) }}
                                </span>
                            </template>

                            <template v-slot:[`item.email`]="{ item }">
                                <span class="text-lowercase">
                                    {{ item.email }}
                                </span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['customers.update'])" v-on="on" @click="editItem(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar empresa</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['customers.delete'])" v-on="on" @click="deleteItem(item)" size="large" class="ml-2">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover empresa</span>
                                    </v-tooltip>


                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- MODAL DE EXCLUSÃO CLIENTE -->
        <v-dialog v-model="dialogConfirmDelete" max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Você tem certeza que deseja excluir o empresa: <strong>{{ itemToDelete ? itemToDelete.name : ''
                        }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="dialogConfirmDelete = false">Cancelar</v-btn>
                    <v-btn color="error darken-1" text @click="confirmDeleteItem">Excluir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "CustomerList",

    data: () => ({
        dataset: {
            data: {}
        },
        dataList: {
            filter: {
                name: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "IE/RG", value: "registration" },
                { text: "E-mail", value: "email" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
        dialogConfirmDelete: false,
        itemToDelete: null,
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        async load() {
            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/v2/customers', { params: { page: this.dataList.options.page, limit: 10, search: this.dataList.filter } });

                console.log("Dados: ", result)

                this.dataList.data = result.data.content.data;

                this.dataList.count = result.data.content.total

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        editItem(item) {
            this.$router.push(`empresas/${item.id}`);
        },

        deleteItem(item) {
            this.itemToDelete = item;
            this.dialogConfirmDelete = true;
        },

        async confirmDeleteItem() {
            if (!this.itemToDelete || !this.itemToDelete.id) {
                this.$dialog.notify.error('Nenhum empresa selecionado para exclusão.', { position: 'top-right', timeout: 3000 });
                this.dialogConfirmDelete = false;
                return;
            }

            this.dialogConfirmDelete = false;
            this.dataList.loading = true;

            try {
                await axios.delete(`/api/v2/customers/${this.itemToDelete.id}`);
                this.$dialog.notify.success('Empresa excluída com sucesso!', { position: 'top-right', timeout: 3000 });
                this.itemToDelete = null;
                await this.load();
            } catch (error) {
                console.error('Erro ao excluir empresa:', error.response || error);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

    },
};
</script>